export * from '@fhs/routing/src/routes/(root)/_layout';
export { default } from '@fhs/routing/src/routes/(root)/_layout';
